import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
export default class MessageForm extends Component {
  render() {
    const { onConfirm, MessageText, isLoading } = this.props;
    return (
      <div>
        <label className="message_text">
          <div>{MessageText}</div>
        </label>
        <hr className="message_hr_line" style={{ marginBottom: 0 }}/>
        <div className="form-group">
          <div className="col-sm-12 message_btngrounp" style={{ padding: '6px 0', textAlign: 'center' }}>
            <button onClick={onConfirm} className="btn btn-default" disabled={isLoading}>
              {this.props.onConfirmName || <FormattedMessage id="SH_Confirm" defaultMessage="確定" />}
            </button>
            {
              this.props.onCancel &&
              <button onClick={this.props.onCancel} className="btn btn-default" disabled={isLoading} style={{ marginLeft: '5px' }}>
                <FormattedMessage id="SH_Cancel" defaultMessage="取消" />
              </button>
            }
          </div>
        </div>
      </div>
    );
  }
}
MessageForm.propTypes = {
  onConfirmName: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  MessageText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  isLoading: PropTypes.bool,
};



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/MessageForm/index.js
 **/